import type { DetailFilterItemPropsType } from './types';

const DetailFilterItem: React.FC<DetailFilterItemPropsType> = (props: DetailFilterItemPropsType) => (
  <label className="relative inline-block min-w-[90px] cursor-pointer max-[600px]:mb-2.5 max-[600px]:mr-0 max-[600px]:w-full">
    <input
      type={`${props.isRadio ? 'radio' : 'checkbox'}`}
      name={props.inputGroupName}
      checked={props.selected}
      readOnly={props.isRadio}
      onChange={!props.isRadio ? props.filterHandlerFn.bind(null, props.filterItem.label, String(props.filterItem.filtervalue)) : null}
      onClick={props.isRadio ? props.filterHandlerFn.bind(null, props.filterItem.label, props.filterItem.filtervalue !== props.selected ? String(props.filterItem.filtervalue) : null) : null}
      className="peer absolute invisible"
    />
    <span className="block w-full border border-[#ccc] px-4 py-1 text-sm text-center text-[#ccc] peer-checked:border-b-accent peer-checked:text-accent peer-focus:text-[#9f9a9a] max-[600px]:w-full">
      {props.filterItem.label}
    </span>
  </label>
);

export { DetailFilterItem };
